import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {Home} from './pages/Home/Home'
import {Month} from './pages/MonthStat/Month'
import { Header } from './pages/Shared/Header/Header';
import { Popup } from './pages/Shared/Popup/Popup';


interface Props{
  city: City;
  cityChange: (currentCity: City) => void;
}

export enum City{
  Lipetsk = 'Липецк',
  Moscow = 'Москва',
}



function App() {
  
  return (
    <div className='global__container'>
       
    <div className="container">
      <Header/>
      <Routes>
        <Route path={"/"}  element={<Home/>} />
        <Route path={"monthstat"}  element={<Month/>} />
      </Routes>
    </div>
    </div>
 
  );
}

export default App;
